import { ArrowRightIcon } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';

import { ROUTES } from '@shared/config/routes';

import { ButtonLink } from '../Button/Button';
import { Container } from '../Container/Container';
import { Reveal } from '../Reveal/Reveal';
import styles from './CtaBand.module.css';

interface CtaBandProps {
  title: string;
  text: string;
  /** Подпись кнопки, если странице нужна своя; по умолчанию — «Mit Karl starten». */
  action?: string | undefined;
}

/**
 * Тёмная CTA-полоса в конце публичной страницы (DESIGN_SYSTEM §7, референсы
 * `main_screen`, `main_screen2`).
 *
 * Одна и та же полоса стоит в конце `/`, `/preise` и `/ueber-uns`, поэтому она
 * компонент, а не три копии разметки: разъехавшийся набор кнопок в конце
 * страницы — самый заметный вид расхождения дизайн-системы.
 *
 * Тёмная поверхность здесь не «случайная тёмная секция посреди светлой
 * страницы»: `--color-ink-900` — та же поверхность, что несёт шапку приложения
 * и подвал, и полоса стоит вплотную к подвалу, продолжая его.
 */
export function CtaBand({ title, text, action }: CtaBandProps) {
  const { t } = useTranslation();

  return (
    <section className={styles.band}>
      <Container>
        <Reveal className={styles.inner}>
          <div>
            <h2 className={styles.title}>{title}</h2>
            <p className={styles.text}>{text}</p>
          </div>
          <div className={styles.actions}>
            {/* Действие одно: витрины каталога в продукте больше нет, и вторая
                кнопка вела бы в удалённый маршрут. */}
            <ButtonLink to={ROUTES.app} size="lg" iconEnd={<ArrowRightIcon size={18} />}>
              {action ?? t('cta.primary')}
            </ButtonLink>
          </div>
        </Reveal>
      </Container>
    </section>
  );
}
